<template>
  <Input
    :class="`email-form-item_${item.id}`"
    :id="options.id"
    :name="options.name"
    :placeholder="options.placeholder"
    :style="style"
  />
</template>

<script>
import FormItemMixin from './Mixin.js'
import Input from '@/shared/components/Input'

export default {
  name: 'EmailFormWidget',
  components: { Input },
  mixins: [FormItemMixin],
  computed: {
    style() {
      return {
        '--placeholder-color': this.itemStyle.placeholderColor,
        '--text-color': this.itemStyle.textColor,
        fontSize: `${this.itemStyle.textSize}px`,
        background: this.itemStyle.backgroundColor,
        borderColor: this.itemStyle.border.color,
        borderWidth: `${this.itemStyle.border.width}px`,
        borderRadius: `${this.itemStyle.border.radius}px`,
        borderStyle: this.itemStyle.border.style,
        paddingTop: `${this.itemStyle.padding.top}px`,
        paddingRight: `${this.itemStyle.padding.right}px`,
        paddingBottom: `${this.itemStyle.padding.bottom}px`,
        paddingLeft: `${this.itemStyle.padding.left}px`,
      }
    },
  },
}
</script>

<style lang="scss">
[class^='email-form-item_'] {
  width: 100%;

  input {
    background-color: transparent !important;
    border: none !important;
    color: var(--text-color);

    &::placeholder {
      color: var(--placeholder-color);
    }
  }
}
</style>
